// extracted by mini-css-extract-plugin
export default {"container":"LinkCursorSelection-module__container--xVQXt","link":"LinkCursorSelection-module__link--2FAce"};